export default {
  namespaced: true,
  billing: {
    title: "Faturamento",
  }
}